import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';

/**
 * Utility class to wrap a collapsible panel around a component
 */
export default class CollapsiblePanel extends React.Component {
    static propTypes = {
        children: PropTypes.object,
        defaultExpanded: PropTypes.bool // should the component start in expanded state
    };

    constructor(props) {
        super(props);
        let collapsed = true;
        if (props.defaultExpanded) {
            collapsed = false;
        }
        this.state = { collapsed };
    }

    toggleDisplay = () => {
        // toggle the value of the collapsed state variable - this will trigger a render any time state changes
        this.setState(prevState => ({
            collapsed: !prevState.collapsed
        }));
    };

    render() {
        // if collapsed, then use display:none on the panel
        let classname;
        if (this.state.collapsed) {
            classname = 'collapsible-panel collapsed';
        } else {
            classname = 'collapsible-panel expanded';
        }
        return (
            <Flexbox flexDirection="row" className={classname} flexGrow={1}>
                <div className={'collapsible-arrow'} onClick={this.toggleDisplay}/>
                <div className={'collapsible-body'}>
                    {this.props.children}
                </div>
            </Flexbox>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/core/CollapsiblePanel.js